import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVendorForesight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "8 4 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 13.9997,
			cy: 9.99978,
			r: 2.60952,
			fill: "#282E9A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2426 14.2426C19.3097 13.1756 19.9355 11.7456 19.9953 10.2377C20.0551 8.72987 19.5445 7.25484 18.5653 6.10664C17.5861 4.95843 16.2101 4.22137 14.7117 4.04236C13.2133 3.86336 11.7025 4.25555 10.4804 5.14077C9.25822 6.02599 8.41453 7.33923 8.11743 8.81875C7.82033 10.2983 8.09166 11.8354 8.87732 13.1238C9.66299 14.4122 10.9053 15.3572 12.3566 15.7706C13.808 16.1839 15.3618 16.0351 16.7084 15.354L15.7787 13.5162C14.8943 13.9635 13.8739 14.0612 12.9207 13.7898C11.9676 13.5183 11.1517 12.8977 10.6357 12.0515C10.1197 11.2054 9.94154 10.1959 10.1367 9.22422C10.3318 8.25255 10.8859 7.39009 11.6885 6.80872C12.4911 6.22736 13.4834 5.96979 14.4674 6.08735C15.4515 6.20492 16.3551 6.68898 16.9982 7.44305C17.6413 8.19713 17.9766 9.16585 17.9374 10.1561C17.8981 11.1464 17.4871 12.0855 16.7863 12.7863L18.2426 14.2426Z",
			fill: "url(#paint0_linear_3939_18084)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 15.4233,
			cy: 8.57954,
			r: .637096,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_3939_18084",
			x1: 8,
			y1: 11.4362,
			x2: 11.5106,
			y2: 16,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#4DD4FF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#7865FF"
			})]
		}) })
	]
});
export default SvgVendorForesight;
